import requestsIcon from '../assets/requests.svg';
import universalIcon from '../assets/universal.svg';
import workIcon from '../assets/work.svg';
import accessIcon from '../assets/access.svg';
import metersIcon from '../assets/meters.svg';

export const readyReports = [
  {
    path: 'executed',
    name: 'Отчёт по заявкам',
    description: 'Анализ всех заявок за выбранный период',
    icon: requestsIcon,
    color: '#e5f4ff',
  },
  {
    path: 'universal',
    name: 'Универсальный отчёт',
    description: 'Гибкая настройка полей и фильтров',
    icon: universalIcon,
    color: '#daf5e7',
  },
  {
    path: 'forma',
    name: 'Форма выработки перечней',
    description: 'Формирование перечней по заданным параметрам',
    icon: workIcon,
    color: '#f3e9ff',
  },
  {
    path: 'delay',
    name: 'Реестр актов недопуска',
    description: 'Список актов недопуска с детализацией',
    icon: accessIcon,
    color: '#ffedcd',
    internal: true,
  },
  {
    path: 'masterCounter',
    name: 'Отчёт по мастер счётчикам',
    description: 'Статистика по установленным счётчикам',
    icon: metersIcon,
    color: '#d6f9fb',
    internal: true,
  },
];
